import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Camera } from "lucide-react";
import api from "../lib/api";
import { setAuth } from "../lib/auth";
import Header from "../components/Header";
import Footer from "../components/Footer";

export default function PhotographerLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      const r = await api.post("/auth/photographer/login", { email, password });
      setAuth(r.data.token, r.data.photographer, "photographer");
      navigate("/photographer/dashboard");
    } catch (e) {
      setErr(e?.response?.data?.detail || "Inloggning misslyckades");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="App">
      <Header />
      <div className="max-w-md mx-auto px-4 py-16">
        <Camera className="w-10 h-10 text-brand mb-4" />
        <p className="label-overline mb-2">Fotograf-inloggning</p>
        <h1 className="font-display font-black uppercase text-white text-4xl mb-6">Logga in</h1>
        <form onSubmit={submit} className="card-surface p-6 space-y-4" data-testid="photographer-login-form">
          <div>
            <label className="label-overline block mb-1">E-post</label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="input-field"
              data-testid="login-email"
            />
          </div>
          <div>
            <label className="label-overline block mb-1">Lösenord</label>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="input-field"
              data-testid="login-password"
            />
          </div>
          {err && <p className="text-destructive text-sm" data-testid="login-error">{err}</p>}
          <button type="submit" disabled={loading} className="btn-primary w-full" data-testid="login-submit">
            {loading ? "Loggar in..." : "Logga in"}
          </button>
          <div className="text-right">
            <Link to="/forgot-password" className="text-xs text-white/60 hover:text-brand" data-testid="forgot-link">
              Glömt lösenord?
            </Link>
          </div>
        </form>
        <p className="text-white/60 text-sm mt-4 text-center">
          Inget konto? <Link to="/photographer/register" className="text-brand hover:underline">Registrera dig</Link>
        </p>
      </div>
      <Footer />
    </div>
  );
}
